import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Card, CardContent, CardActions,
  Button, Avatar
} from '@mui/material';
import {
  AddToDrive as GoogleDriveIcon,
  Cloud as OneDriveIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

const DrivesLandingPage = () => {
  const { chatbotId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Drives | KlonIT Web Application';
  }, []);

  const cards = [
    {
      title: 'Google Drive',
      description: 'Connect your Google Drive to import and sync documents, spreadsheets, and files for chatbot training.',
      icon: <GoogleDriveIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      link: `/chatbot/${chatbotId}/connectors/gdrive`,
      color: '#1976d2'
    },
    {
      title: 'One Drive',
      description: 'Connect your Microsoft OneDrive to import and sync documents, spreadsheets, and files for chatbot training.',
      icon: <OneDriveIcon sx={{ fontSize: 60, color: '#0078d4' }} />,
      link: `/chatbot/${chatbotId}/connectors/onedrive`,
      color: '#0078d4'
    }
  ];

  return (
    <Box sx={{ p: 3, mt: 10 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700}>
          Drives
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Connect your cloud drives to import knowledge
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: '0.3s',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-4px)'
                }
              }}
              onClick={() => navigate(card.link)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: `${card.color}15`,
                    margin: '0 auto 16px'
                  }}
                >
                  {card.icon}
                </Avatar>
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ bgcolor: card.color }}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DrivesLandingPage;
